import CryptoJS from 'crypto-js';

const SECRET_KEY = 'I-aEn_2025'; // Considera usar una clave más larga para mayor seguridad

export const encryptId = (id: number): string => {
  const encrypted = CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();
  
  // Hacer URL-safe reemplazando caracteres problemáticos
  return encrypted
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};

export const decryptId = (encryptedId: string): number => {
  // Restaurar caracteres originales
  let restored = encryptedId
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  
  // Agregar padding necesario para Base64
  while (restored.length % 4) {
    restored += '=';
  }
  
  const bytes = CryptoJS.AES.decrypt(restored, SECRET_KEY);
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);

  return Number(decrypted);
};